import { Variant } from '../../types'

export const hasMultipleVariants = (variants: Variant[]) => variants.length > 1
